import { gsap } from 'gsap';

export const fadeIn = (element, delay = 0) => {
  gsap.fromTo(
    element,
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out', delay }
  );
};

export const slideIn = (element, direction = 'left', delay = 0) => {
  const x = direction === 'left' ? -50 : 50;
  gsap.fromTo(
    element,
    { opacity: 0, x },
    { opacity: 1, x: 0, duration: 0.8, ease: 'power3.out', delay }
  );
};

export const scaleHover = (element) => {
  gsap.to(element, {
    scale: 1.05,
    duration: 0.3,
    ease: 'power2.out',
  });
};

export const scaleReset = (element) => {
  gsap.to(element, {
    scale: 1,
    duration: 0.3,
    ease: 'power2.out',
  });
};